import { render } from "./dashBoard.vue?vue&type=template&id=1d3347f0&ts=true"
import script from "./dashBoard.vue?vue&type=script&lang=ts"
export * from "./dashBoard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__